// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 시장지수현황 화면 */

/* ── 툴바 ── */
.mi-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.mi-period-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.mi-period-label input[type="radio"] {
  cursor: pointer;
}

.mi-custom-range {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 4px;
}

.mi-date-input {
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #d0d7de;
  border-radius: 4px;
  background: #fff;
}

.mi-btn {
  padding: 5px 14px;
  font-size: 13px;
  border: 1px solid #d0d7de;
  border-radius: 4px;
  background: #f6f8fa;
  cursor: pointer;
  white-space: nowrap;
}
.mi-btn.primary {
  background: #4a90e2;
  color: #fff;
  border-color: #4a90e2;
}
.mi-btn.primary:hover { background: #3a7bd5; }

/* ── 탭 ── */
.mi-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #d0d7de;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.mi-tab-btn {
  padding: 8px 20px;
  font-size: 13px;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  cursor: pointer;
  color: #666;
  margin-bottom: -2px;
  white-space: nowrap;
  transition: color 0.15s;
}
.mi-tab-btn:hover { color: #4a90e2; }
.mi-tab-btn.active {
  color: #4a90e2;
  border-bottom-color: #4a90e2;
  font-weight: 600;
}

/* ── 로딩 / 데이터 없음 ── */
.mi-loading,
.mi-no-data {
  text-align: center;
  color: #888;
  padding: 40px 0;
  font-size: 13px;
}

/* ── 차트 레이아웃 ── */

/* 국내지수: 상단 2열 + 하단 전체 */
.mi-charts-domestic {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

/* 2×2 그리드 */
.mi-charts-2x2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

/* 2개종목비교 탭: 6개 그래프 세로 1열 배치 (데이터 그리드 없음, 그래프 높이 확대) */
.mi-compare-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

/* 하단 전체 차트 (국내지수 코스피200) */
.mi-chart-full {
  grid-column: 1 / -1;
}

/* ── 차트 패널 ── */
.mi-chart-panel {
  border: 1px solid #e8ecf0;
  border-radius: 6px;
  padding: 10px 12px 8px;
  background: #fff;
}

.mi-chart-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 6px;
}

.mi-chart-title {
  font-size: 12px;
  font-weight: 600;
  color: #24292f;
}

.mi-chart-latest {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.mi-latest-val {
  font-size: 14px;
  font-weight: 700;
  color: #24292f;
}

.mi-latest-diff {
  font-size: 11px;
  font-weight: 600;
}

/* ── 커스텀 툴팁 ── */
.mi-tooltip {
  background: rgba(30, 30, 30, 0.88);
  border-radius: 6px;
  padding: 8px 12px;
  color: #fff;
  font-size: 12px;
  line-height: 1.6;
  pointer-events: none;
}
.mi-tt-date { color: #aaa; font-size: 11px; }
.mi-tt-val  { font-weight: 700; font-size: 13px; }
.mi-tt-diff { font-size: 11px; }

/* ── 데이터 그리드 ── */
.mi-grid-wrap {
  max-height: 420px;
  overflow: auto;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  margin-top: 4px;
}

.mi-grid {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.mi-grid th {
  position: sticky;
  top: 0;
  background: #f6f8fa;
  border-bottom: 1px solid #d0d7de;
  padding: 6px 8px;
  text-align: center;
  font-weight: 600;
  color: #24292f;
  white-space: nowrap;
  z-index: 1;
}

.mi-grid thead tr:first-child th {
  border-bottom: 1px solid #d0d7de;
  top: 0;
}

.mi-grid thead tr:nth-child(2) th {
  top: 29px;
  border-bottom: 2px solid #d0d7de;
  font-weight: 500;
  color: #555;
  font-size: 11px;
  background: #f0f2f5;
}

.mi-grid td {
  padding: 5px 8px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

.mi-grid tr:last-child td { border-bottom: none; }
.mi-grid tr:hover td { background: #f8f9fa; }

.mi-th-date {
  text-align: center;
  vertical-align: middle;
}

.mi-th-group {
  text-align: center;
  border-left: 1px solid #e0e4ea;
}

.mi-th-val, .mi-th-diff {
  text-align: right;
}
.mi-th-val { border-left: 1px solid #e0e4ea; }

.mi-td-date {
  text-align: center;
  color: #555;
  white-space: nowrap;
  font-size: 12px;
}

.mi-td-val {
  text-align: right;
  font-weight: 600;
  color: #24292f;
  white-space: nowrap;
  border-left: 1px solid #f0f0f0;
  min-width: 80px;
}

.mi-td-diff {
  text-align: right;
  white-space: nowrap;
  font-size: 11px;
  min-width: 100px;
}

/* ── DualChart 헤더 ── */
.mi-chart-header--dual {
  align-items: flex-start;
}

.mi-dual-left {
  flex: 1 1;
  min-width: 0;
}

.mi-chart-desc {
  font-size: 10px;
  color: #999;
  margin-top: 3px;
  line-height: 1.4;
}

.mi-dual-legend {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
  margin-left: 8px;
  padding-top: 1px;
  white-space: nowrap;
}

/* ── 상관관계 그리드 ── */
.mi-th-corr {
  text-align: right;
  min-width: 80px;
}

.mi-td-corr {
  text-align: right;
  padding: 4px 8px;
  white-space: nowrap;
  min-width: 80px;
  vertical-align: middle;
  border-bottom: 1px solid #f0f0f0;
}

.mi-corr-val {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.mi-corr-diff {
  font-size: 10px;
  white-space: nowrap;
  margin-top: 1px;
}

/* ── ? 아이콘 버튼 ── */
.mi-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 5px;
  border-radius: 50%;
  border: 1px solid #b0bec5;
  background: #eceff1;
  color: #546e7a;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  vertical-align: middle;
  flex-shrink: 0;
  padding: 0;
  transition: background 0.15s, border-color 0.15s;
}
.mi-info-btn:hover {
  background: #4a90e2;
  border-color: #4a90e2;
  color: #fff;
}

/* ── 모달 오버레이 ── */
.mi-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* ── 모달 박스 ── */
.mi-modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22);
  width: 620px;
  max-width: 94vw;
  max-height: 82vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mi-modal-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px 12px;
  border-bottom: 1px solid #e0e4ea;
  flex-shrink: 0;
}

.mi-modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
}

.mi-modal-close {
  border: none;
  background: none;
  font-size: 18px;
  color: #888;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.mi-modal-close:hover { color: #333; }

.mi-modal-bd {
  overflow-y: auto;
  padding: 16px 20px 20px;
  flex: 1 1;
}

/* ── 모달 내용 공통 ── */
.mi-info-body {
  font-size: 13px;
  color: #333;
  line-height: 1.65;
}

.mi-info-section {
  margin-bottom: 18px;
}
.mi-info-section:last-child { margin-bottom: 0; }

.mi-info-h4 {
  font-size: 13px;
  font-weight: 700;
  color: #1a3a6e;
  margin: 0 0 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #e8ecf4;
}

.mi-info-section p {
  margin: 0;
  color: #444;
}

.mi-info-ul {
  margin: 0;
  padding-left: 18px;
}
.mi-info-ul li {
  margin-bottom: 8px;
  color: #444;
}
.mi-info-ul li:last-child { margin-bottom: 0; }

/* ── 모달 내부 테이블 ── */
.mi-info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin-top: 2px;
}
.mi-info-table th {
  background: #f0f2f8;
  padding: 6px 10px;
  text-align: left;
  font-weight: 600;
  color: #24292f;
  border: 1px solid #d8dde8;
}
.mi-info-table td {
  padding: 5px 10px;
  border: 1px solid #e8ecf0;
  vertical-align: middle;
}
.mi-info-table tbody tr:nth-child(even) td {
  background: #fafbff;
}

/* ── VKOSPI 과거 데이터 수집 버튼 ── */
.mi-collect-btn {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 8px;
  font-size: 10px;
  border: 1px solid #b0bec5;
  border-radius: 3px;
  background: #f0f4f8;
  color: #546e7a;
  cursor: pointer;
  white-space: nowrap;
  vertical-align: middle;
  transition: background 0.15s, border-color 0.15s;
}
.mi-collect-btn:hover:not(:disabled) {
  background: #e1ecf4;
  border-color: #4a90e2;
  color: #4a90e2;
}
.mi-collect-btn:disabled {
  opacity: 0.55;
  cursor: default;
}

/* ── VKOSPI 상태 배지 ── */
.mi-vkospi-status {
  font-size: 11px;
  font-weight: 600;
  margin-left: 4px;
}

/* ── 국내 KOSPI-VKOSPI 상관관계 섹션 ── */
.mi-domestic-corr {
  margin-top: 16px;
  border: 1px solid #e0e4ea;
  border-radius: 6px;
  padding: 10px 12px 8px;
  background: #fafbff;
}

.mi-domestic-corr-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 12px;
}

.mi-domestic-corr-left {
  flex: 1 1;
  min-width: 0;
}

.mi-domestic-corr-title {
  font-size: 13px;
  font-weight: 700;
  color: #24292f;
}

.mi-domestic-corr-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.mi-corr-coef-badge {
  font-size: 12px;
  color: #333;
  background: #e8ecf4;
  padding: 3px 10px;
  border-radius: 12px;
  white-space: nowrap;
}

.mi-corr-desc-txt {
  color: #888;
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/status/MarketIndexPage.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C,YAAY;AACZ;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,oBAAoB,cAAc,EAAE;AACpC;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,kBAAkB;;AAElB,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA,cAAc,WAAW,EAAE,eAAe,EAAE;AAC5C,cAAc,gBAAgB,EAAE,eAAe,EAAE;AACjD,cAAc,eAAe,EAAE;;AAE/B,kBAAkB;AAClB;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,MAAM;AACR;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,4BAA4B,mBAAmB,EAAE;AACjD,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;AACA,aAAa,8BAA8B,EAAE;;AAE7C;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA,wBAAwB,WAAW,EAAE;;AAErC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;AACA,8BAA8B,gBAAgB,EAAE;;AAEhD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA,4BAA4B,gBAAgB,EAAE;;AAE9C,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* 시장지수현황 화면 */\n\n/* ── 툴바 ── */\n.mi-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.mi-period-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  color: #444;\n  cursor: pointer;\n  user-select: none;\n}\n.mi-period-label input[type=\"radio\"] {\n  cursor: pointer;\n}\n\n.mi-custom-range {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 4px;\n}\n\n.mi-date-input {\n  padding: 4px 8px;\n  font-size: 13px;\n  border: 1px solid #d0d7de;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.mi-btn {\n  padding: 5px 14px;\n  font-size: 13px;\n  border: 1px solid #d0d7de;\n  border-radius: 4px;\n  background: #f6f8fa;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.mi-btn.primary {\n  background: #4a90e2;\n  color: #fff;\n  border-color: #4a90e2;\n}\n.mi-btn.primary:hover { background: #3a7bd5; }\n\n/* ── 탭 ── */\n.mi-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid #d0d7de;\n  margin-bottom: 12px;\n  flex-shrink: 0;\n}\n\n.mi-tab-btn {\n  padding: 8px 20px;\n  font-size: 13px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: none;\n  cursor: pointer;\n  color: #666;\n  margin-bottom: -2px;\n  white-space: nowrap;\n  transition: color 0.15s;\n}\n.mi-tab-btn:hover { color: #4a90e2; }\n.mi-tab-btn.active {\n  color: #4a90e2;\n  border-bottom-color: #4a90e2;\n  font-weight: 600;\n}\n\n/* ── 로딩 / 데이터 없음 ── */\n.mi-loading,\n.mi-no-data {\n  text-align: center;\n  color: #888;\n  padding: 40px 0;\n  font-size: 13px;\n}\n\n/* ── 차트 레이아웃 ── */\n\n/* 국내지수: 상단 2열 + 하단 전체 */\n.mi-charts-domestic {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n/* 2×2 그리드 */\n.mi-charts-2x2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n/* 2개종목비교 탭: 6개 그래프 세로 1열 배치 (데이터 그리드 없음, 그래프 높이 확대) */\n.mi-compare-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n/* 하단 전체 차트 (국내지수 코스피200) */\n.mi-chart-full {\n  grid-column: 1 / -1;\n}\n\n/* ── 차트 패널 ── */\n.mi-chart-panel {\n  border: 1px solid #e8ecf0;\n  border-radius: 6px;\n  padding: 10px 12px 8px;\n  background: #fff;\n}\n\n.mi-chart-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.mi-chart-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #24292f;\n}\n\n.mi-chart-latest {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.mi-latest-val {\n  font-size: 14px;\n  font-weight: 700;\n  color: #24292f;\n}\n\n.mi-latest-diff {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n/* ── 커스텀 툴팁 ── */\n.mi-tooltip {\n  background: rgba(30, 30, 30, 0.88);\n  border-radius: 6px;\n  padding: 8px 12px;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1.6;\n  pointer-events: none;\n}\n.mi-tt-date { color: #aaa; font-size: 11px; }\n.mi-tt-val  { font-weight: 700; font-size: 13px; }\n.mi-tt-diff { font-size: 11px; }\n\n/* ── 데이터 그리드 ── */\n.mi-grid-wrap {\n  max-height: 420px;\n  overflow: auto;\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  margin-top: 4px;\n}\n\n.mi-grid {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.mi-grid th {\n  position: sticky;\n  top: 0;\n  background: #f6f8fa;\n  border-bottom: 1px solid #d0d7de;\n  padding: 6px 8px;\n  text-align: center;\n  font-weight: 600;\n  color: #24292f;\n  white-space: nowrap;\n  z-index: 1;\n}\n\n.mi-grid thead tr:first-child th {\n  border-bottom: 1px solid #d0d7de;\n  top: 0;\n}\n\n.mi-grid thead tr:nth-child(2) th {\n  top: 29px;\n  border-bottom: 2px solid #d0d7de;\n  font-weight: 500;\n  color: #555;\n  font-size: 11px;\n  background: #f0f2f5;\n}\n\n.mi-grid td {\n  padding: 5px 8px;\n  border-bottom: 1px solid #f0f0f0;\n  vertical-align: middle;\n}\n\n.mi-grid tr:last-child td { border-bottom: none; }\n.mi-grid tr:hover td { background: #f8f9fa; }\n\n.mi-th-date {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.mi-th-group {\n  text-align: center;\n  border-left: 1px solid #e0e4ea;\n}\n\n.mi-th-val, .mi-th-diff {\n  text-align: right;\n}\n.mi-th-val { border-left: 1px solid #e0e4ea; }\n\n.mi-td-date {\n  text-align: center;\n  color: #555;\n  white-space: nowrap;\n  font-size: 12px;\n}\n\n.mi-td-val {\n  text-align: right;\n  font-weight: 600;\n  color: #24292f;\n  white-space: nowrap;\n  border-left: 1px solid #f0f0f0;\n  min-width: 80px;\n}\n\n.mi-td-diff {\n  text-align: right;\n  white-space: nowrap;\n  font-size: 11px;\n  min-width: 100px;\n}\n\n/* ── DualChart 헤더 ── */\n.mi-chart-header--dual {\n  align-items: flex-start;\n}\n\n.mi-dual-left {\n  flex: 1;\n  min-width: 0;\n}\n\n.mi-chart-desc {\n  font-size: 10px;\n  color: #999;\n  margin-top: 3px;\n  line-height: 1.4;\n}\n\n.mi-dual-legend {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  font-size: 10px;\n  font-weight: 700;\n  flex-shrink: 0;\n  margin-left: 8px;\n  padding-top: 1px;\n  white-space: nowrap;\n}\n\n/* ── 상관관계 그리드 ── */\n.mi-th-corr {\n  text-align: right;\n  min-width: 80px;\n}\n\n.mi-td-corr {\n  text-align: right;\n  padding: 4px 8px;\n  white-space: nowrap;\n  min-width: 80px;\n  vertical-align: middle;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.mi-corr-val {\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.mi-corr-diff {\n  font-size: 10px;\n  white-space: nowrap;\n  margin-top: 1px;\n}\n\n/* ── ? 아이콘 버튼 ── */\n.mi-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  margin-left: 5px;\n  border-radius: 50%;\n  border: 1px solid #b0bec5;\n  background: #eceff1;\n  color: #546e7a;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  vertical-align: middle;\n  flex-shrink: 0;\n  padding: 0;\n  transition: background 0.15s, border-color 0.15s;\n}\n.mi-info-btn:hover {\n  background: #4a90e2;\n  border-color: #4a90e2;\n  color: #fff;\n}\n\n/* ── 모달 오버레이 ── */\n.mi-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* ── 모달 박스 ── */\n.mi-modal {\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22);\n  width: 620px;\n  max-width: 94vw;\n  max-height: 82vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.mi-modal-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px 12px;\n  border-bottom: 1px solid #e0e4ea;\n  flex-shrink: 0;\n}\n\n.mi-modal-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n.mi-modal-close {\n  border: none;\n  background: none;\n  font-size: 18px;\n  color: #888;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n}\n.mi-modal-close:hover { color: #333; }\n\n.mi-modal-bd {\n  overflow-y: auto;\n  padding: 16px 20px 20px;\n  flex: 1;\n}\n\n/* ── 모달 내용 공통 ── */\n.mi-info-body {\n  font-size: 13px;\n  color: #333;\n  line-height: 1.65;\n}\n\n.mi-info-section {\n  margin-bottom: 18px;\n}\n.mi-info-section:last-child { margin-bottom: 0; }\n\n.mi-info-h4 {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a3a6e;\n  margin: 0 0 8px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #e8ecf4;\n}\n\n.mi-info-section p {\n  margin: 0;\n  color: #444;\n}\n\n.mi-info-ul {\n  margin: 0;\n  padding-left: 18px;\n}\n.mi-info-ul li {\n  margin-bottom: 8px;\n  color: #444;\n}\n.mi-info-ul li:last-child { margin-bottom: 0; }\n\n/* ── 모달 내부 테이블 ── */\n.mi-info-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  margin-top: 2px;\n}\n.mi-info-table th {\n  background: #f0f2f8;\n  padding: 6px 10px;\n  text-align: left;\n  font-weight: 600;\n  color: #24292f;\n  border: 1px solid #d8dde8;\n}\n.mi-info-table td {\n  padding: 5px 10px;\n  border: 1px solid #e8ecf0;\n  vertical-align: middle;\n}\n.mi-info-table tbody tr:nth-child(even) td {\n  background: #fafbff;\n}\n\n/* ── VKOSPI 과거 데이터 수집 버튼 ── */\n.mi-collect-btn {\n  display: inline-block;\n  padding: 2px 8px;\n  margin-left: 8px;\n  font-size: 10px;\n  border: 1px solid #b0bec5;\n  border-radius: 3px;\n  background: #f0f4f8;\n  color: #546e7a;\n  cursor: pointer;\n  white-space: nowrap;\n  vertical-align: middle;\n  transition: background 0.15s, border-color 0.15s;\n}\n.mi-collect-btn:hover:not(:disabled) {\n  background: #e1ecf4;\n  border-color: #4a90e2;\n  color: #4a90e2;\n}\n.mi-collect-btn:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n/* ── VKOSPI 상태 배지 ── */\n.mi-vkospi-status {\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n/* ── 국내 KOSPI-VKOSPI 상관관계 섹션 ── */\n.mi-domestic-corr {\n  margin-top: 16px;\n  border: 1px solid #e0e4ea;\n  border-radius: 6px;\n  padding: 10px 12px 8px;\n  background: #fafbff;\n}\n\n.mi-domestic-corr-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  gap: 12px;\n}\n\n.mi-domestic-corr-left {\n  flex: 1;\n  min-width: 0;\n}\n\n.mi-domestic-corr-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #24292f;\n}\n\n.mi-domestic-corr-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.mi-corr-coef-badge {\n  font-size: 12px;\n  color: #333;\n  background: #e8ecf4;\n  padding: 3px 10px;\n  border-radius: 12px;\n  white-space: nowrap;\n}\n\n.mi-corr-desc-txt {\n  color: #888;\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
